import { render, staticRenderFns } from "./EditAjustesDest.vue?vue&type=template&id=6d3506cf&scoped=true"
import script from "./EditAjustesDest.vue?vue&type=script&lang=js"
export * from "./EditAjustesDest.vue?vue&type=script&lang=js"
import style0 from "./EditAjustesDest.vue?vue&type=style&index=0&id=6d3506cf&prod&scoped=true&lang=css"
import style1 from "./EditAjustesDest.vue?vue&type=style&index=1&id=6d3506cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3506cf",
  null
  
)

export default component.exports